import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import {
  moduleCompilersAction,
  getOrganizationStaffAction
} from "../../../../store/actions";
import InfoBox from "../../../../../../ui/InfoDrawer/components/InfoBox";
import AddButton from "../../../../../../ui/AddButton";
import AddAuthorModal from "./AddAuthorModal";
import EditOrganizationModal from "./EditOrganizationModal";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import ClearIcon from "@material-ui/icons/Clear";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

const Compilers = ({
  moduleCompilers,
  compilers,
  organizationList,
  getOrganizationStaff,
  organizationStaff,
  moduleId,
  initialState = { organization: {}, staff: [] }
}) => {
  const { organization, authors } = compilers;

  const [showAuthorDialog, setShowAuthorDialog] = useState(false);
  const [showOrganizationDialog, setShowOrganizationDialog] = useState(false);
  const [openDeleteAuthorModal, setOpenDeleteAuthorModal] = React.useState(
    false
  );
  const [activeAuthor, setActiveAuthor] = React.useState();
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (compilers) {
      const compilers = {
        organization: organization,
        staff: authors
      };
      setState(compilers);
    }
  }, [authors, compilers, getOrganizationStaff, organization]);

  useEffect(() => {
    if (organization) {
      getOrganizationStaff(organization.id);
    }
  }, [getOrganizationStaff, organization]);

  const editOrganization = () => {
    const organization = {
      type: "set-organization",
      module: moduleId,
      organization: state.organization.id
    };
    moduleCompilers(organization);
    setShowOrganizationDialog(false);
  };

  const addAuthor = () => {
    const authors = {
      type: "add-author",
      module: moduleId,
      persons: state.staff.map(item => item.personId)
    };
    moduleCompilers(authors);
    setShowAuthorDialog(false);
  };

  const removeAuthor = personId => {
    const author = {
      type: "remove-author",
      module: moduleId,
      person: personId
    };
    moduleCompilers(author);
  };

  const change = (field, value) => {
    const newState = {
      ...state,
      [field]: value
    };
    setState(newState);
    field === "organization" && getOrganizationStaff(value.id);
  };

  return (
    <div>
      <DeleteConfirmationModal
        open={openDeleteAuthorModal}
        handleClose={() => setOpenDeleteAuthorModal(false)}
        modalText="Удалить составителя"
        additionalText={activeAuthor && activeAuthor.personName}
        onConfirm={() =>
          removeAuthor(activeAuthor.personId) || setOpenDeleteAuthorModal(false)
        }
      />
      <AddAuthorModal
        title="Добавление составителя"
        showDialog={showAuthorDialog}
        closeDialog={() => setShowAuthorDialog(false)}
        organizationList={organizationList}
        change={change}
        organizationStaff={organizationStaff}
        state={state}
        addAuthor={addAuthor}
      />
      <EditOrganizationModal
        title="Редактирование правообладателя"
        showDialog={showOrganizationDialog}
        closeDialog={() => setShowOrganizationDialog(false)}
        organizationList={organizationList}
        change={change}
        state={state}
        editOrganization={editOrganization}
      />
      <Box fontSize={14} mb={0}>
        Правообладатель
      </Box>
      <Grid item style={{ display: "flex", alignItems: "flex-start" }}>
        <InfoBox
          image={organization && organization.logo}
          desc={organization && organization.name}
        />
        <Tooltip title="Редактировать" placement="top">
          <IconButton onClick={() => setShowOrganizationDialog(true)}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid container alignItems="center">
        <Box fontSize={14} mb={0} mr={2}>
          Составители модуля
        </Box>
        <AddButton onClick={() => setShowAuthorDialog(true)} />
      </Grid>
      <Grid container alignItems="flex-start">
        {authors &&
          authors.map(item => (
            <Grid
              item
              key={item.personId}
              style={{ display: "flex", alignItems: "flex-start" }}
            >
              <InfoBox
                name={item.personName}
                image={item.personAvatar}
                desc={item.postName}
              />
              <Tooltip title="Удалить" placement="top">
                <IconButton
                  onClick={() =>
                    setOpenDeleteAuthorModal(true) || setActiveAuthor(item)
                  }
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  compilers: state.modules.allModuleCompilers,
  organizationList: state.persons.organizations,
  organizationStaff: state.modules.organizationStaff
});

const mapDispatchToProps = dispatch => ({
  moduleCompilers: data => dispatch(moduleCompilersAction(data)),
  getOrganizationStaff: id => dispatch(getOrganizationStaffAction(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Compilers);
